import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetopanvelcabs() {



  const cardData = {




keyword: "Pune to Panvel Cabs",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to Panvel Cabs for families, couples, business travelers, students, senior citizens, and groups planning convenient intercity travel. Customers can book chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other suitable vehicles for one-way journeys, round trips, business visits, family functions, airport transfers, railway station travel, and customized sightseeing plans. With experienced drivers, clean and well-maintained vehicles, comfortable seating, practical luggage space, flexible pickup locations across Pune, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes travel from Pune to Panvel smooth and convenient. Travelers can also customize their journey to cover popular attractions, religious places, nature destinations, commercial areas, and nearby locations around Panvel.",

topPlaces: [
  {
    title: "Panvel City",
    description: "Panvel is an important city in the Mumbai Metropolitan Region and serves as a major gateway toward Navi Mumbai, Mumbai, and several coastal destinations. Travelers from Pune may visit Panvel for business, family functions, education, shopping, or onward travel. Garud Cab Service provides direct chauffeur-driven cab transportation with flexible pickup and drop arrangements."
  },
  {
    title: "Karnala Fort",
    description: "Karnala Fort is a popular historic hill fort near Panvel surrounded by the Karnala Bird Sanctuary and green Sahyadri landscapes. It is suitable for history enthusiasts, trekkers, photographers, and nature lovers. Customers traveling from Pune can include Karnala in their itinerary and enjoy comfortable private transportation with flexible sightseeing arrangements."
  },
  {
    title: "Karnala Bird Sanctuary",
    description: "Karnala Bird Sanctuary is a scenic forest destination near Panvel known for its birdlife, greenery, trekking trails, and natural surroundings. Families and nature enthusiasts can enjoy a peaceful day trip away from busy urban areas. Garud Cab Service provides comfortable cab options from Pune with convenient pickup, drop, and return travel facilities."
  },
  {
    title: "Imagicaa",
    description: "Imagicaa near Khopoli is a popular entertainment destination offering theme park attractions, rides, and family-friendly experiences. It is frequently visited by families and groups traveling from Pune toward the Panvel-Khopoli region. Customers can book a private cab for direct transportation with flexible schedules and sufficient space for passengers and luggage."
  },
  {
    title: "Navi Mumbai",
    description: "Navi Mumbai is a major planned urban area close to Panvel and is known for business districts, residential areas, shopping centers, educational institutions, and commercial developments. Travelers from Pune can use a private cab for convenient door-to-door transportation. Garud Cab Service offers suitable vehicles for corporate travel, family visits, and personal work."
  },
  {
    title: "Belapur",
    description: "Belapur is an important business and administrative hub of Navi Mumbai and attracts professionals for corporate meetings, government work, and commercial activities. Travelers from Pune can book a private cab for direct transportation without changing vehicles. Customers can choose comfortable chauffeur-driven vehicles with flexible pickup and drop locations."
  },
  {
    title: "Matheran",
    description: "Matheran is a scenic hill station near the Panvel region known for forest trails, viewpoints, pleasant weather, and peaceful mountain surroundings. Since vehicles are restricted inside the hill station, a cab can conveniently take travelers to the appropriate entry point. Garud Cab Service can arrange Pune-to-Matheran travel with flexible sightseeing and return plans."
  },
  {
    title: "Kharghar",
    description: "Kharghar is a well-developed Navi Mumbai locality known for residential communities, educational institutions, commercial areas, and nearby natural attractions. Travelers from Pune may visit for business, education, family requirements, or personal work. Customers can book a private cab with professional chauffeurs for comfortable direct travel and flexible schedules."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a popular coastal destination accessible from the Panvel region and is known for beaches, forts, resorts, and relaxing seaside experiences. Families and groups traveling from Pune can combine Panvel with Alibaug for a longer coastal trip. Garud Cab Service provides spacious private cabs with flexible one-way and round-trip travel options."
  },
  {
    title: "Juinagar",
    description: "Juinagar is a well-connected Navi Mumbai locality with residential, commercial, and railway connectivity and can be an important destination for business and personal travel. Passengers from Pune can choose direct cab transportation for convenient door-to-door travel. Garud Cab Service provides suitable vehicles with comfortable seating, luggage space, and professional chauffeur assistance."
  }
],


"services": [
{
"name": "Pune to Panvel Cab",
"description": "Book Pune to Panvel Cab for comfortable and convenient intercity transportation with professional chauffeurs and well-maintained AC vehicles. The service is suitable for families, business travelers, tourists, and individuals looking for private travel from Pune to Panvel."
},
{
"name": "Pune to Panvel Taxi",
"description": "Choose Pune to Panvel Taxi for a comfortable and practical journey between Pune and Panvel. Sedan, SUV, Innova, and other vehicle options can be arranged according to passenger count, luggage, travel timing, and individual transportation requirements."
},
{
"name": "Cab from Pune to Panvel",
"description": "Reserve a Cab from Pune to Panvel for direct private transportation with convenient pickup from your preferred location in Pune. The service is suitable for families, corporate travelers, tourists, and passengers requiring comfortable chauffeur-driven intercity travel."
},
{
"name": "Taxi from Pune to Panvel",
"description": "Book a Taxi from Pune to Panvel for convenient point-to-point travel with professional driver assistance. Comfortable AC vehicles can be arranged for business journeys, family visits, personal travel, sightseeing, and other long-distance transportation needs."
},
{
"name": "Pune to Panvel Cab Service",
"description": "Choose Pune to Panvel Cab Service for reliable chauffeur-driven transportation with flexible pickup arrangements and comfortable vehicles. The service is suitable for corporate passengers, families, tourists, and individuals planning scheduled travel between Pune and Panvel."
},
{
"name": "Pune to Panvel Taxi Fare",
"description": "Check Pune to Panvel Taxi Fare according to the selected vehicle category, pickup location, journey type, and travel requirements. Sedan, SUV, Innova, and spacious vehicle options can be arranged for comfortable private transportation."
},
{
"name": "Pune to Panvel One Way Cab",
"description": "Choose Pune to Panvel One Way Cab for convenient point-to-point transportation without requiring a return booking. The service is suitable for business travel, relocation, family visits, personal journeys, and passengers traveling to Panvel for one-way requirements."
},
{
"name": "Pune to Panvel Round Trip Taxi",
"description": "Book Pune to Panvel Round Trip Taxi for convenient transportation with return travel included in the journey plan. The service is suitable for families, corporate travelers, tourists, and passengers planning meetings, visits, shopping, sightseeing, or same-day return trips."
},
{
"name": "Pune to Panvel Cab Booking",
"description": "Make Pune to Panvel Cab Booking for a scheduled private journey with convenient vehicle selection and pickup arrangements. Customers can select suitable sedan, SUV, Innova, or premium options based on passenger count, luggage, and travel preferences."
},
{
"name": "Cheap Pune to Panvel Cab",
"description": "Book a Cheap Pune to Panvel Cab for economical private transportation while maintaining basic travel comfort. Practical sedan and other vehicle options can be arranged for students, individuals, families, business travelers, and budget-conscious passengers."
},
{
"name": "Best Pune to Panvel Taxi",
"description": "Choose the Best Pune to Panvel Taxi for comfortable private transportation with professional chauffeurs and well-maintained vehicles. The service is suitable for business travel, family journeys, personal visits, sightseeing, and scheduled intercity transportation."
},
{
"name": "Sedan Pune to Panvel Cab",
"description": "Book Sedan Pune to Panvel Cab for comfortable AC transportation suitable for individuals, couples, and small families. Sedan vehicles provide practical seating and luggage space for business trips, personal travel, and convenient long-distance journeys."
},
{
"name": "SUV Pune to Panvel Taxi",
"description": "Choose SUV Pune to Panvel Taxi for spacious and comfortable transportation with additional seating and luggage capacity. The service is suitable for families, groups, corporate travelers, tourists, and passengers looking for a more spacious road travel option."
},
{
"name": "Innova Pune to Panvel Cab",
"description": "Book Innova Pune to Panvel Cab for spacious and comfortable intercity travel suitable for families and small groups. The vehicle offers practical seating, luggage capacity, and chauffeur-driven convenience for business trips, personal journeys, and family travel."
},
{
"name": "Fast Route Cab Pune Panvel",
"description": "Choose Fast Route Cab Pune Panvel for convenient private transportation between Pune and Panvel with experienced chauffeurs familiar with intercity travel. The service is suitable for passengers looking for scheduled pickup, comfortable AC travel, and efficient journey planning."
},
{
"name": "Panvel to Pune Cab",
"description": "Book Panvel to Pune Cab for comfortable return-route transportation with convenient pickup from Panvel. Professional chauffeurs and well-maintained vehicles make the service suitable for business travelers, families, tourists, students, and individuals traveling toward Pune."
},
{
"name": "Cab from Panvel to Pune",
"description": "Reserve a Cab from Panvel to Pune for direct private travel with flexible pickup arrangements. The service is suitable for passengers returning from Panvel, corporate travelers, families, tourists, and individuals requiring comfortable chauffeur-driven transportation."
},
{
"name": "Panvel to Pune Cab Charges",
"description": "Check Panvel to Pune Cab Charges according to the selected vehicle, pickup location, journey requirements, and travel schedule. Sedan, SUV, Innova, and other comfortable options can be arranged for private intercity transportation."
},
{
"name": "Pune to Panvel Cab Price",
"description": "Find Pune to Panvel Cab Price based on the vehicle category, pickup location, travel timing, and journey type. Customers can select practical sedan, spacious SUV, Innova, or premium vehicles according to their transportation and luggage requirements."
},
{
"name": "Pune to Panvel Taxi",
"description": "Book Pune to Panvel Taxi for convenient private transportation with professional chauffeur assistance and comfortable AC interiors. The service is suitable for families, corporate passengers, tourists, and individuals traveling between Pune and Panvel."
},
{
"name": "Pune to Navi Mumbai Cab",
"description": "Choose Pune to Navi Mumbai Cab for comfortable private transportation from Pune to Navi Mumbai. Sedan, SUV, Innova, and larger vehicle options can be arranged for business travel, family journeys, airport transfers, sightseeing, and personal visits."
},
{
"name": "Pune to Mira Road Taxi",
"description": "Book Pune to Mira Road Taxi for convenient intercity transportation with direct pickup and destination drop. The service is suitable for families, corporate travelers, tourists, and individuals requiring comfortable AC travel with professional chauffeur assistance."
},
{
"name": "Pune to Borivali Cab",
"description": "Choose Pune to Borivali Cab for comfortable private travel from Pune to Borivali with flexible pickup arrangements. The service is suitable for business trips, family visits, personal journeys, and passengers looking for convenient chauffeur-driven transportation."
},
{
"name": "Pune to Andheri Taxi",
"description": "Book Pune to Andheri Taxi for convenient transportation between Pune and Andheri. Comfortable AC vehicles with professional drivers can be arranged for corporate travel, business meetings, family visits, airport connections, and personal journeys."
},
{
"name": "Pune to Vasai Cab",
"description": "Choose Pune to Vasai Cab for reliable private transportation with direct pickup from Pune and destination drop in Vasai. The service is suitable for families, business travelers, tourists, and passengers planning comfortable long-distance travel."
},
{
"name": "Pune to Bhiwandi Taxi",
"description": "Book Pune to Bhiwandi Taxi for comfortable intercity transportation with experienced chauffeurs and AC vehicles. The service is suitable for business visits, industrial travel, family journeys, personal trips, and passengers carrying regular luggage."
},
{
"name": "Pune to Palghar Cab",
"description": "Choose Pune to Palghar Cab for convenient private transportation from Pune to Palghar. Sedan, SUV, Innova, and larger vehicles can be arranged for families, tourists, corporate passengers, and individuals requiring comfortable outstation travel."
},
{
"name": "Pune to Mumbai Airport Taxi",
"description": "Book Pune to Mumbai Airport Taxi for convenient airport transportation from Pune to Mumbai Airport. The service is suitable for business travelers, families, tourists, and passengers carrying luggage who require scheduled pickup and direct airport drop."
},
{
"name": "Pune to Panvel Cab Service",
"description": "Choose Pune to Panvel Cab Service for reliable chauffeur-driven transportation with comfortable AC vehicles and flexible pickup options. The service can accommodate business trips, family journeys, personal visits, sightseeing, and regular intercity travel."
},
{
"name": "Pune to Panvel Taxi Service",
"description": "Book Pune to Panvel Taxi Service for comfortable point-to-point transportation with professional drivers and convenient scheduling. Sedan, SUV, Innova, and other vehicle categories can be selected according to passenger and luggage requirements."
},
{
"name": "Pune to Panvel Cab Booking",
"description": "Make Pune to Panvel Cab Booking in advance to arrange a private vehicle according to your preferred pickup time and location. The service is suitable for individuals, families, corporate passengers, tourists, and groups planning intercity travel."
},
{
"name": "Best Pune to Panvel Cab",
"description": "Choose the Best Pune to Panvel Cab for a comfortable and convenient journey supported by experienced chauffeurs and well-maintained vehicles. The service is suitable for business travel, family trips, personal visits, sightseeing, and regular intercity transportation."
},
{
"name": "One Way Pune to Panvel Cab",
"description": "Book One Way Pune to Panvel Cab for direct transportation without adding a return journey to the booking. It is suitable for passengers relocating, attending business appointments, visiting family, or traveling to Panvel for personal requirements."
},
{
"name": "Round Trip Pune to Panvel Taxi",
"description": "Choose Round Trip Pune to Panvel Taxi for convenient travel with return transportation planned as part of the journey. The service is suitable for same-day visits, business meetings, family functions, shopping trips, and sightseeing requirements."
},
{
"name": "Cheap Pune to Panvel Cab",
"description": "Book Cheap Pune to Panvel Cab for budget-friendly private transportation with practical vehicle options. The service is suitable for students, individuals, families, and business travelers looking for economical intercity travel with comfortable AC transportation."
},
{
"name": "24x7 Pune to Panvel Cab Service",
"description": "Choose 24x7 Pune to Panvel Cab Service for transportation arrangements across different travel schedules. The service is suitable for early-morning departures, late-night journeys, business travel, emergency travel requirements, airport connections, and planned intercity trips."
},
{
"name": "Outstation Cab Pune to Panvel",
"description": "Book Outstation Cab Pune to Panvel for private chauffeur-driven transportation between Pune and Panvel. Comfortable vehicles can be arranged for families, business travelers, tourists, groups, and individuals requiring reliable long-distance travel."
},
{
"name": "Pune to Navi Mumbai Cab",
"description": "Choose Pune to Navi Mumbai Cab for convenient private travel between Pune and Navi Mumbai. The service is suitable for corporate passengers, families, tourists, airport travelers, and individuals requiring direct transportation with flexible pickup and drop arrangements."
},
{
"name": "Pune to Kharghar Taxi",
"description": "Book Pune to Kharghar Taxi for comfortable intercity transportation with professional chauffeur service. The vehicle is suitable for business travel, family visits, personal journeys, educational trips, and passengers requiring direct travel to Kharghar."
},
{
"name": "Pune to Kamothe Cab",
"description": "Choose Pune to Kamothe Cab for convenient private transportation from Pune to Kamothe. Sedan, SUV, and Innova options can be arranged for families, business travelers, tourists, and individuals according to passenger count and luggage requirements."
},
{
"name": "Pune to Belapur Taxi",
"description": "Book Pune to Belapur Taxi for comfortable transportation between Pune and Belapur with convenient pickup arrangements. The service is suitable for corporate travel, business meetings, family visits, personal journeys, and passengers requiring chauffeur-driven intercity travel."
},
{
"name": "Pune to Nerul Cab",
"description": "Choose Pune to Nerul Cab for direct private transportation with comfortable AC vehicles and experienced chauffeurs. The service is suitable for business travelers, families, tourists, students, and individuals planning scheduled travel to Nerul."
},
{
"name": "Pune to Taloja Taxi",
"description": "Book Pune to Taloja Taxi for convenient private travel from Pune to Taloja with professional driver assistance. The service is suitable for industrial visits, business travel, family journeys, personal trips, and passengers looking for comfortable intercity transportation."
},
{
"name": "Pune to Mumbai Airport Cab",
"description": "Choose Pune to Mumbai Airport Cab for scheduled airport transportation with direct pickup from Pune and convenient terminal drop. Comfortable sedan, SUV, Innova, and premium options are suitable for families, corporate travelers, tourists, and passengers with luggage."
},
{
"name": "Pune to Uran Taxi",
"description": "Book Pune to Uran Taxi for comfortable private transportation from Pune to Uran. The service is suitable for families, corporate travelers, tourists, business visits, personal journeys, and passengers requiring a direct chauffeur-driven intercity cab."
}
],
"tableData": [
["Pune to Panvel Cab", "Pune to Panvel Taxi"],
["Cab from Pune to Panvel", "Taxi from Pune to Panvel"],
["Pune to Panvel Cab Service", "Pune to Panvel Taxi Fare"],
["Pune to Panvel One Way Cab", "Pune to Panvel Round Trip Taxi"],
["Pune to Panvel Cab Booking", "Cheap Pune to Panvel Cab"],
["Best Pune to Panvel Taxi", "Sedan Pune to Panvel Cab"],
["SUV Pune to Panvel Taxi", "Innova Pune to Panvel Cab"],
["Fast Route Cab Pune Panvel", "Panvel to Pune Cab"],
["Cab from Panvel to Pune", "Panvel to Pune Cab Charges"],
["Pune to Panvel Cab Price", "Pune to Panvel Taxi"],
["Pune to Navi Mumbai Cab", "Pune to Mira Road Taxi"],
["Pune to Borivali Cab", "Pune to Andheri Taxi"],
["Pune to Vasai Cab", "Pune to Bhiwandi Taxi"],
["Pune to Palghar Cab", "Pune to Mumbai Airport Taxi"],
["Pune to Panvel Cab Service", "Pune to Panvel Taxi Service"],
["Pune to Panvel Cab Booking", "Best Pune to Panvel Cab"],
["One Way Pune to Panvel Cab", "Round Trip Pune to Panvel Taxi"],
["Cheap Pune to Panvel Cab", "24x7 Pune to Panvel Cab Service"],
["Outstation Cab Pune to Panvel", "Pune to Navi Mumbai Cab"],
["Pune to Kharghar Taxi", "Pune to Kamothe Cab"],
["Pune to Belapur Taxi", "Pune to Nerul Cab"],
["Pune to Taloja Taxi", "Pune to Mumbai Airport Cab"],
["Pune to Uran Taxi", "Pune to Panvel Cab Price"]
],



whychoose: [
  {
    WhyChooseheading: "Pune to Panvel Cabs for Convenient Intercity Travel",
    WhyChoosedescription: "A private cab makes the journey from Pune to Panvel convenient for families, professionals, students, couples, and groups who prefer direct road transportation arranged around their travel schedule."
  },
  {
    WhyChooseheading: "Pickup from Your Preferred Pune Location",
    WhyChoosedescription: "Start your trip from a home, hotel, office, residential society, railway station area, or another convenient location in Pune and travel directly toward your Panvel destination."
  },
  {
    WhyChooseheading: "Direct Door-to-Door Transportation",
    WhyChoosedescription: "Travellers can avoid unnecessary vehicle changes by choosing a direct cab from Pune to their preferred location in Panvel, making the journey particularly useful for passengers carrying luggage."
  },
  {
    WhyChooseheading: "Comfortable Choice for Families & Groups",
    WhyChoosedescription: "Families, couples, senior citizens, and small groups can select a vehicle according to passenger count, luggage quantity, and comfort requirements for a relaxed intercity journey."
  },
  {
    WhyChooseheading: "Useful for Business & Professional Travel",
    WhyChoosedescription: "Professionals travelling to Panvel for meetings, office work, client visits, industrial requirements, site inspections, or other business commitments can arrange a dedicated private cab."
  },
  {
    WhyChooseheading: "One-Way Cab for Flexible Travel Plans",
    WhyChoosedescription: "Passengers visiting Panvel for relocation, education, personal work, family visits, or professional commitments can choose a one-way cab without requiring the same vehicle for the return."
  },
  {
    WhyChooseheading: "Round-Trip Option for Planned Returns",
    WhyChoosedescription: "When a return journey to Pune is required, travellers can arrange a round-trip cab around their appointment, family event, business schedule, or preferred return timing."
  },
  {
    WhyChooseheading: "Simple Booking with Garud Cab Service",
    WhyChoosedescription: "Provide your Pune pickup point, Panvel destination, travel date, passenger details, luggage requirements, preferred vehicle, and trip type to Garud Cab Service for booking assistance."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Panvel Cabs?",
    answer: "Yes, Garud Cab Service provides private Pune to Panvel cab services for families, professionals, couples, students, groups, and passengers travelling for personal or business purposes."
  },
  {
    question: "Can I book a one-way cab from Pune to Panvel?",
    answer: "Yes, one-way cab service can be arranged for passengers who need direct transportation from Pune to their preferred destination in Panvel."
  },
  {
    question: "Can I reserve a round-trip Pune to Panvel cab?",
    answer: "Yes, round-trip cab arrangements can be planned according to your Panvel visit, family function, business schedule, appointment, or preferred return date."
  },
  {
    question: "Is Pune to Panvel cab suitable for families?",
    answer: "Yes, private cab travel is suitable for families and groups who want to travel together with convenient pickup, comfortable seating, and space for their luggage."
  },
  {
    question: "Can I use the cab for business travel to Panvel?",
    answer: "Yes, the cab can be used for office visits, client meetings, industrial work, site inspections, professional appointments, and other business-related transportation needs."
  },
  {
    question: "Can I book a cab for relocation to Panvel?",
    answer: "Yes, a private cab can be considered for relocation or personal shifting requirements depending on the luggage quantity and capacity of the selected vehicle."
  },
  {
    question: "Can I get pickup from my home or office in Pune?",
    answer: "Yes, pickup can be arranged from your home, hotel, office, residential society, railway station area, or another preferred location in Pune."
  },
  {
    question: "Can the cab drop me directly at my destination in Panvel?",
    answer: "Yes, direct drop-off can be arranged at your home, hotel, office, residential area, business location, or another accessible destination in Panvel."
  },
  {
    question: "Can I travel with luggage in the Pune to Panvel cab?",
    answer: "Yes, passengers can carry luggage according to the available space in the selected vehicle. Larger luggage requirements should be mentioned during booking."
  },
  {
    question: "How can I book a Pune to Panvel Cab?",
    answer: "Share your Pune pickup location, Panvel destination, travel date, passenger details, luggage requirements, preferred vehicle, and one-way or round-trip preference with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Pratik Jadhav",
    feedback: "I travelled from Pune to Panvel for work and selected a private cab for the direct journey. Being able to start from my preferred location made the trip convenient for my schedule.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Komal Shinde",
    feedback: "Our family booked a Pune to Panvel cab for a personal visit. Travelling together in one vehicle made the journey easier, especially with children and luggage.",
    rating: 5
  }
];
















  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Panvel Cabs",
  "image": "https://garudcabs.com/assets/images/pune-to-panvel-cabs.webp",
  "description": "Book Pune to Panvel Cabs with Garud Cab for safe, comfortable, and reliable intercity travel. Get affordable one way and round trip taxi services between Pune and Panvel for business trips, family journeys, airport transfers, and city-to-city travel. Choose Sedan, Ertiga, SUV, Innova, and Innova Crysta vehicles with convenient pickup and drop facilities.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-panvel-cabs"
  }
};





  return (
    <div>


<Helmet>
  <title>Pune to Panvel Cabs | One Way & Round Trip Taxi | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to Panvel Cabs with Garud Cab for comfortable and reliable intercity travel. Get affordable one way and round trip taxi services with Sedan, Ertiga, SUV, Innova, and Innova Crysta options for business, family, airport, and city-to-city journeys."
  />

  <meta
    name="keywords"
    content="Pune to Panvel Cab, Pune to Panvel Taxi, Cab from Pune to Panvel, Taxi from Pune to Panvel, Pune to Panvel Cab Service, Pune to Panvel Taxi Fare, Pune to Panvel One Way Cab, Pune to Panvel Round Trip Taxi, Pune to Panvel Cab Booking, Cheap Pune to Panvel Cab, Best Pune to Panvel Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/83.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetopanvelcabs;